module.exports = __webpack_public_path__ + "static/media/bodiometer-pro-logo-stacked.b4333aa2.svg";